import { dateTime } from '@/_shared';
const testDiv = document.createElement('div');

export function historyItemStringConverter(str: string, isDate = false): string {
  if (dateTime.isValid(str) && isDate) {
    return dateTime.format(str, 'YYYY-MM-DD');
  } else if (/<[a-z][\s\S]*>/i.test(str)) {
    testDiv.innerHTML = str;
    return testDiv.innerText;
  }

  return str + '';
}

export function getType(
  newName: string,
  newId: number | undefined,
  oldName: string,
  oldId: number | undefined
): 'ADD' | 'DELETE' | 'UPDATE' | undefined {
  let type = undefined;
  if (newId === oldId && newName !== oldName) {
    type = 'UPDATE';
  } else {
    if (oldName === '' && newName !== '') {
      type = 'ADD';
    } else if (oldName !== '' && newName === '') {
      type = 'DELETE';
    }
  }

  return type as 'ADD' | 'DELETE' | 'UPDATE';
}

export function newValueCalculator(
  oldValueIds: number[],
  currentValueIds: number[],
  lastEventType?: 'ADD' | 'DELETE' | 'UPDATE'
) {
  let calValue = currentValueIds;
  if (lastEventType === 'DELETE') {
    calValue = [...new Set([...currentValueIds, ...oldValueIds])];
    // add old value here
  } else if (lastEventType === 'ADD') {
    calValue = currentValueIds.filter((item) => !oldValueIds.includes(item));
    // remove old value here
  } else if (lastEventType === 'UPDATE') {
    if (oldValueIds.length === 1 && currentValueIds.length === 1) {
      return oldValueIds;
    } else {
      return currentValueIds;
    }
  }

  return calValue;
}
